<nb-card>
	<nb-card-body>
		<div class="form-group">
			<label class="label cols-sm-3">{{
				'SETTINGS_FILE_STORAGE.FILE_PROVIDER' | translate
			}}</label>
			<nb-select
				class="d-block"
				size="medium"
				[(selected)]="settings.fileStorageProvider"
			>
				<nb-option
					*ngFor="let providerName of fileStorageProviders"
					[value]="providerName.value"
				>
					{{ providerName.label | titlecase }}
				</nb-option>
			</nb-select>
		</div>
		<ng-template
			[ngIf]="settings.fileStorageProvider == FileStorageProviderEnum.S3"
		>
			<nb-card>
				<nb-card-header>
					<h6>
						{{ 'SETTINGS_FILE_STORAGE.S3_DETAILS' | translate }}
					</h6>
				</nb-card-header>
				<nb-card-body>
					<div class="form-group row">
						<label class="label col-sm-3">{{
							'SETTINGS_FILE_STORAGE.ACCESS_KEY_ID' | translate
						}}</label>
						<div class="col-sm-9">
							<input
								name="aws_access_key_id"
								[(ngModel)]="settings.aws_access_key_id"
								nbInput
								fullWidth
								class="w-100"
								[placeholder]="
									'SETTINGS_FILE_STORAGE.ACCESS_KEY_ID'
										| translate
								"
							/>
						</div>
					</div>
					<div class="form-group row">
						<label class="label col-sm-3">{{
							'SETTINGS_FILE_STORAGE.SECRET_ACCESS_KEY'
								| translate
						}}</label>
						<div class="col-sm-9">
							<input
								name="aws_secret_access_key"
								[(ngModel)]="settings.aws_secret_access_key"
								nbInput
								fullWidth
								class="w-100"
								[placeholder]="
									'SETTINGS_FILE_STORAGE.SECRET_ACCESS_KEY'
										| translate
								"
							/>
						</div>
					</div>
					<div class="form-group row">
						<label class="label col-sm-3">{{
							'SETTINGS_FILE_STORAGE.REGION' | translate
						}}</label>
						<div class="col-sm-9">
							<input
								name="aws_default_region"
								[(ngModel)]="settings.aws_default_region"
								nbInput
								fullWidth
								class="w-100"
								[placeholder]="
									'SETTINGS_FILE_STORAGE.REGION' | translate
								"
							/>
						</div>
					</div>
					<div class="form-group row">
						<label class="label col-sm-3">{{
							'SETTINGS_FILE_STORAGE.BUCKET' | translate
						}}</label>
						<div class="col-sm-9">
							<input
								name="aws_bucket"
								[(ngModel)]="settings.aws_bucket"
								nbInput
								fullWidth
								class="w-100"
								[placeholder]="
									'SETTINGS_FILE_STORAGE.BUCKET' | translate
								"
							/>
						</div>
					</div>
				</nb-card-body>
			</nb-card>
		</ng-template>
	</nb-card-body>
	<nb-card-footer class="text-right">
		<button class="mr-3" (click)="submit()" nbButton status="success">
			{{ 'BUTTONS.SAVE' | translate }}
		</button>
	</nb-card-footer>
</nb-card>
